import angular from 'angular';
import uiModal from 'angular-ui-bootstrap/src/modal';
import { DashboardComponent } from './dashboard.component.js';
import { KomentarWidgetComponent } from './komentarWidget.component.js';
import animateFaze from './animateFaze.directive.js';
import { heatCalendar } from './heatCalendar.directive.js';

const dashboard = angular.module('dashboard', [uiModal]);

dashboard.component('dashboard', DashboardComponent);
dashboard.component('komentarWidget', KomentarWidgetComponent);
dashboard.directive('animateFaze', animateFaze);
dashboard.directive('heatCalendar', heatCalendar);

export { dashboard };



// WEBPACK FOOTER //
// ./app/components/dashboard/dashboard.js